import { deleteUser } from 'aws-amplify/auth'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { type UserInput } from '@skop-app/lib-types'

import { updateUserStrict } from '@/services/user/user.mutation'

export const useUserUpdate = (
  options?: UseMutationOptions<void, Error, Partial<UserInput>, unknown>,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['updateUser'],
    mutationFn: updateUser,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user'],
      })
    },
    onError: (error) => {
      throw error
    },
    ...options,
  })
}

export const updateUser = updateUserStrict

export const deleteUserAccount = async () => {
  try {
    return await deleteUser()
  } catch (error) {
    console.error('Error deleting user', error)
    throw error
  }
}
